import React, { useState, useEffect } from 'react';
import Button from 'sushiweb/Button';
import Modal from 'sushiweb/Modal';
import PropTypes from 'prop-types';
import _noop from 'lodash-es/noop';
import { useNavigate } from 'react-router-dom';
import { P } from 'sushiweb/Typography/Text';
import { paymentPurposeEnum } from '../constants';
import { CHECKOUT_ONLINE_PAY_ROUTE } from '../../../../constants/routes';
import { formatAmountInRupees } from '../../../../helpers';
import {
  AmountInput,
  FormWrapper,
  InputWrapper,
  ModalTitle,
  PayButtonWrapper,
  QuickAmountButton,
  QuickAmountRow,
  SummaryWrapper,
  UpdatedLimitAmount,
} from './styles';

const QUICK_AMOUNT_PERCENTAGES = [0.25, 0.5, 1];
const NON_NUMERIC_REGEX = /[^0-9.]/g;
const MULTIPLE_DECIMALS_REGEX = /(\..*?)\..*/g;

const IncreaseBudgetLimitModal = ({ isVisible, closeModal, creditLimit }) => {
  const navigate = useNavigate();
  const [amount, setAmount] = useState('');

  useEffect(() => {
    if (!isVisible) {
      setAmount('');
    }
  }, [isVisible]);

  const quickAmounts = QUICK_AMOUNT_PERCENTAGES.map(percentage =>
    Math.round(creditLimit * percentage),
  );

  const updateAmount = val => {
    setAmount(val.replace(NON_NUMERIC_REGEX, '').replace(MULTIPLE_DECIMALS_REGEX, '$1'));
  };

  const numericAmount = Number.parseFloat(amount) || 0;
  const disabled = numericAmount <= 0;

  const payNow = () => {
    localStorage.onlinePaymentAmount = numericAmount;
    localStorage.paymentPurpose = paymentPurposeEnum.PAYMENT_PURPOSE_SECURITY_DEPOSIT;
    closeModal();
    navigate(CHECKOUT_ONLINE_PAY_ROUTE);
  };

  return (
    <Modal
      visible={isVisible}
      onClose={closeModal}
      showCloseIcon
      titleComponent={<ModalTitle>Increase budget limit</ModalTitle>}
      isCentered
      width='60rem'
      borderRadius='2rem'
    >
      <FormWrapper>
        <InputWrapper>
          <AmountInput
            fullWidth
            label='Amount to add'
            value={amount}
            onChange={updateAmount}
          />
        </InputWrapper>
        <QuickAmountRow>
          {quickAmounts.map(value => (
            <QuickAmountButton
              key={value}
              type='button'
              selected={numericAmount === value}
              onClick={() => setAmount(String(value))}
            >
              {`+ ${formatAmountInRupees(value)}`}
            </QuickAmountButton>
          ))}
        </QuickAmountRow>
        <SummaryWrapper>
          <P>Updated monthly limit</P>
          <UpdatedLimitAmount>
            {formatAmountInRupees(creditLimit + numericAmount)}
          </UpdatedLimitAmount>
        </SummaryWrapper>
        <PayButtonWrapper>
          <Button disabled={disabled} onClick={payNow}>
            {`Pay ${formatAmountInRupees(numericAmount)}`}
          </Button>
        </PayButtonWrapper>
      </FormWrapper>
    </Modal>
  );
};

IncreaseBudgetLimitModal.propTypes = {
  isVisible: PropTypes.bool,
  closeModal: PropTypes.func,
  creditLimit: PropTypes.number,
};

IncreaseBudgetLimitModal.defaultProps = {
  isVisible: false,
  closeModal: _noop,
  creditLimit: 0,
};

export default IncreaseBudgetLimitModal;
